module.exports = __webpack_public_path__ + "static/media/galeryAbout6.b2146e34.jpg";